import { useGraphqlQuery } from "@mzara/component";
import { TAppointmentBoard } from "@mzara/graphql";
import _ from "lodash";
import { AppointmentBoardInvitationsQuery } from "../queries/AppointmentBoardQuery";

export const useAppointmentBoardInvitationsQuery = (id: number, suspense?: boolean) => {

    return useGraphqlQuery<AppointmentBoardInvitationsQuery, TAppointmentBoard>(
        new AppointmentBoardInvitationsQuery({ id }), {suspense, enabled: id !== undefined});
};